import "./ContactForm.css";
import { useState } from "react";

// Collects the payee address for the Email and PhoneNumber data types. The field name matches what the
// SDK reads off the payment data, so the value reaches the initiation request untouched.
function ContactForm({
  field,
  label,
  inputType,
  inputMode,
  autoComplete,
  placeholder,
  hint,
  onSubmit
}) {
  const [value, setValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit === "function") {
      onSubmit({
        [field]: value.trim()
      });
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor={field}>{label}</label>
        <input
          type={inputType}
          id={field}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          inputMode={inputMode}
          autoComplete={autoComplete}
          placeholder={placeholder}
          required
        />
        {hint && <small className="contact-form-hint">{hint}</small>}
      </div>

      <button className="primary-action" type="submit">
        Submit
      </button>
    </form>
  );
}

export default ContactForm;
